import React, { useState, useEffect } from "react";

import IconButton from "@mui/material/IconButton";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

import { FaqItem } from "model/faq";
import css from "../content.module.scss";
import { Link } from "@mui/material";

export interface Props {
  title: string;
  items: FaqItem[];
  defaultExpanded?: boolean;
  expandAll?: boolean;
  onClick: (event: any, item: FaqItem) => void;
  hideToggle?: boolean;
}

const FaqGroup: React.FC<Props> = (props) => {
  const {
    title,
    items,
    defaultExpanded,
    expandAll,
    onClick,
    hideToggle = false,
  } = props;

  const [expanded, setExpanded] = useState<boolean>(!!defaultExpanded);

  useEffect(() => {
    setExpanded(!!expandAll || !!defaultExpanded);
  }, [expandAll, defaultExpanded]);

  return (
    <div className={css.faqGroup}>
      <div
        className={css.titleRow}
        onClick={() => !hideToggle && setExpanded(!expanded)}
      >
        <div className={css.title}>{title}</div>
        {!hideToggle && (
          <IconButton
            aria-label="delete"
            onClick={() => setExpanded(!expanded)}
          >
            {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        )}
      </div>
      {expanded && (
        <div className={css.items}>
          {items.map((item) => {
            if (item.hidden) return undefined;
            return (
              <div className={css.item} key={item.id}>
                <Link
                  href={"/" + item.id}
                  onClick={(event) => onClick(event, item)}
                >
                  {item.title}
                </Link>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default FaqGroup;
